<template>
  <div class="remove-article-watch-modal">
    <h3>{{ tStatic('removeArticleWatchModalTitle') }}</h3>
    <p>{{ tStatic('removeArticleWatchModalDescription') }}</p>
    <div class="remove-article-watch-modal__actions">
      <oie-base-button :text="tStatic('removeArticleWatchModalConfirmButtonLabel')" css-classes="button--dark-red" @click="deleteArticleWatch"></oie-base-button>
      <oie-base-button :text="tStatic('modalCancel')" css-classes="button--true-ghost" @click="closeModal"></oie-base-button>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteArticleWatch() {
      httpService.delete('article-watch/delete', { id: this.options.id }).then(() => {
        this.options.onHide()
        this.closeModal()
      })
    },
    closeModal() {
      this.publish('modal.hide.remove-article-watch')
    }
  }
}
</script>

<style lang="scss">

.remove-article-watch-modal {
  > h3 {
    @include h3-bold;
    margin: 0;
  }

  > p {
    margin: 1rem 0 1.5rem 0;
  }
}
.remove-article-watch-modal__actions {
  display: flex;
  gap: 1rem;
}
</style>
